import { BaseEntity } from "./BaseEntity";
import { UserRepresentation } from "./UserRepresentation";;

export interface CustomerMeteringPoint extends BaseEntity {
    customerNumber?: string;
    meteringPointNumber?: string;
    errorCode?: string;
    ownerRelationExists?: boolean;
    ownerUsers?: UserRepresentation[];
    hasOwnerUserInfoBeenShown?: boolean;
}

export function CustomerMeteringPointFromJSON(json: any): CustomerMeteringPoint {
    if ((json === null) || (json === undefined)) {
        return json;
    }

    return {
        'id': json['id'],
        'customerNumber': json['customerNumber'],
        'meteringPointNumber': json['meteringPointNumber'],
        'errorCode': json['errorCode'],
        'ownerRelationExists': json['ownerRelationExists'],
        'ownerUsers': json['ownerUsers']
    }
}

export function CustomerMeteringPointToJson(value?: CustomerMeteringPoint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    return {
        'id': value.id,
        'customerNumber': value.customerNumber,
        'meteringPointNumber': value.meteringPointNumber,
        'errorCode': value.errorCode,
        'ownerRelationExists': value.ownerRelationExists,
        'ownerUsers': value.ownerUsers
    }
}